import { DeleteRequest, GetExcelRequest, GetRequest, PostRequest, PutRequest } from '../../service';

const ControllerName = "Role"

export const ExportRolesExcel = (link) =>
    GetExcelRequest(ControllerName + link)

export const GetRolesLookup = () =>
    GetRequest(ControllerName + "/lookup")

export const GetAllRoles = (link) =>
    GetRequest(ControllerName + link)

export const GetRoleDetails = (roleID) =>
    GetRequest(ControllerName + "/" + roleID)

export const AddRole = (RoleData) =>
    PostRequest(ControllerName, RoleData)

export const UpdateRole = (data) => {
    return PutRequest(`${ControllerName}/${data?.id}`, data)
}

export const DeleteRole = (roleID) =>
    DeleteRequest(ControllerName + "/" + roleID)

